// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { changePasswordStyles } from "@steiner/Overrides/Widgets/ChangePassword/ChangePassword";
import { color } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

changePasswordStyles.passwordRequirementsGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};

changePasswordStyles.passwordGridContainer = {
    gap: 8,
};

changePasswordStyles.userInformationTitle = {
    variant: "h4",
    as: "h2",
};

changePasswordStyles.passwordGridItemContainer = {
    gap: 12,
    css: css`
        &&& {
            max-width: 450px;
            margin: 0;
        }
    `,
};

changePasswordStyles.actionsWrapper = {
    css: css`
        margin-top: 25px;
        padding-top: 25px;
        border-top: 1px solid ${color("common.border")};
    `,
};

changePasswordStyles.userInformationTextGridItem = {
    width: 12,
    css: css`
        padding-bottom: 2px;
    `,
};

changePasswordStyles.userInformationText = {
    variant: "h4",
    as: "h2",
    css: css`
        margin-bottom: 0;
    `,
};

changePasswordStyles.signOutWarningText = {
    css: css`
        padding-bottom: 24px;
        display: block;
    `,
};
